// extracted by mini-css-extract-plugin
module.exports = {"content":"MbapiAdminSection_content__1rhel","illustration":"MbapiAdminSection_illustration__2KBpw"};